import React, { useRef, useState } from "react";

const OtpInput = ({ length = 6, onChange, disabled = false }) => {
  const [values, setValues] = useState(Array(length).fill(""));
  const [complete, setComplete] = useState(false);
  const inputs = useRef([]);

  const commit = (newValues) => {
    const joined = newValues.join("");
    const isFull = joined.length === length;
    setComplete(isFull);
    onChange(joined);
  };

  const handleChange = (index, e) => {
    if (disabled) return;
    const val = e.target.value.replace(/\D/g, "").slice(-1);
    const newValues = [...values];
    newValues[index] = val;
    setValues(newValues);
    commit(newValues);
    if (val && index < length - 1) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (values[index]) {
        const newValues = [...values];
        newValues[index] = "";
        setValues(newValues);
        commit(newValues);
      } else if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    if (disabled) return;
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    if (!pasted) return;
    const newValues = Array(length).fill("");
    pasted.split("").forEach((char, i) => { newValues[i] = char; });
    setValues(newValues);
    commit(newValues);
    const focusIdx = Math.min(pasted.length, length - 1);
    inputs.current[focusIdx]?.focus();
  };

  return (
    <div className="login-otp-boxes">
      {values.map((val, i) => {
        const isFilled = val !== "";
        const isAllFilled = complete && isFilled;
        let className = "login-otp-box";
        if (isAllFilled) className += " login-otp-box--complete";
        else if (isFilled) className += " login-otp-box--filled";

        return (
          <input
            key={i}
            ref={(el) => (inputs.current[i] = el)}
            className={className}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={val}
            disabled={disabled}
            onChange={(e) => handleChange(i, e)}
            onKeyDown={(e) => handleKeyDown(i, e)}
            onPaste={handlePaste}
          />
        );
      })}
    </div>
  );
};

export default OtpInput;
